<template>
    <div class="hide_scroll" style="overflow: auto;" ref="wrapper" @touchmove.stop="detectMoved">
        <slot></slot>
    </div>
</template>

<script>
import { SCROLL_DIRECTION } from '@/Constants'
import _ from 'lodash';

export default {
    name: 'AutoScrollWrapper',
    props: {
        scrollDirection: {
            type: String,
            default: SCROLL_DIRECTION.TOP
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.startScrolling()
        })
    },
    created() {
        this.stopScrolling = _.debounce(this.stopScrolling, 1000);
    },
    data() {
        return {
            SCROLL_DIRECTION: SCROLL_DIRECTION,
            is_scrolling: false,
            scroll_animation_frame: null
        }
    },
    deactivated() {
        cancelAnimationFrame(this.scroll_animation_frame);
        this.scroll_animation_frame = null;
    },
    methods: {
        setScrollDirection(wrapper) {
            if (this.scrollDirection === SCROLL_DIRECTION.TOP) {
                return wrapper.scrollTop
            } else if (this.scrollDirection === SCROLL_DIRECTION.LEFT) {
                return wrapper.scrollLeft
            }
        },
        setMaxScrollDirection(wrapper) {
            if (this.scrollDirection === SCROLL_DIRECTION.TOP) {
                return wrapper.scrollHeight - wrapper.clientHeight;
            } else if (this.scrollDirection === SCROLL_DIRECTION.LEFT) {
                return wrapper.scrollWidth - wrapper.clientWidth;
            }
        },
        stopScrolling() {
            cancelAnimationFrame(this.scroll_animation_frame);
            this.is_scrolling = false;
            this.startScrolling()
        },
        detectMoved() {
            this.is_scrolling = true;
            this.stopScrolling();
        },
        moveScroll(scrollFloat, wrapper) {
            if (this.scrollDirection === SCROLL_DIRECTION.TOP) {
                wrapper.scrollTop = Math.floor(scrollFloat);
            } else if (this.scrollDirection === SCROLL_DIRECTION.LEFT) {
                wrapper.scrollLeft = Math.floor(scrollFloat);
            }
        },
        startScrolling() {
            const wrapper = this.$refs.wrapper;
            let scrollFloat = this.setScrollDirection(wrapper) || 0
            const speed = 0.5;

            const scroll = () => {
                if (this.is_scrolling) {
                    return;
                }

                scrollFloat += speed;

                const maxScroll = this.setMaxScrollDirection(wrapper)
                if (scrollFloat >= maxScroll - 5) {
                    scrollFloat = 0;
                }
                this.moveScroll(scrollFloat, wrapper)
                this.scroll_animation_frame = requestAnimationFrame(scroll);
            };

            this.scroll_animation_frame = requestAnimationFrame(scroll);
        },
    }
}
</script>

<style scoped></style>